import React from 'react';
import { AlgoversePaymentModalProps } from './types.type';
import withResponsive from 'v3/common/hooks/withResponsive';
import Mobile from './mobile';
import Web from './web';

const ResponsiveComponent = withResponsive(Mobile, Web);

const AlgoversePaymentModal: React.FC<AlgoversePaymentModalProps> = ({
  orderId,
  showModal,
  setShowModal,
  selectedPlan,
}) => {
  return (
    <div className="algoverse-payment-modal">
      <ResponsiveComponent
        orderId={orderId}
        showModal={showModal}
        setShowModal={setShowModal}
        selectedPlan={selectedPlan}
      />
    </div>
  );
};

export default AlgoversePaymentModal;
